export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-fast-forward-76983ef95f0e445a048b95bff54c8fa3.svg";